let Data = [
    {

      "id": 1,
      "title": "News is free?",
      "body": "The news was free for only 10 articles in the free version."
    },
    {
      "id": 2,
      "title": "How many languages available?",
      "body": "15 languages are availables. 5 Indian languages and 10 foreign languages."
    },
    {

      "id": 3,
      "title": "Latest News website!",
      "body": "Latest updates & news from around the world."
    },
    {

      "id": 4,
      "title": "It's Safe?",
      "body": "Yes! it's totally safe for everyone."
    }
  ];
  export default Data